// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2iq8u","header":"PatientBlock_header__1hf4j","label":"PatientBlock_label__16cYv","option":"PatientBlock_option__327Ib"};